// Need to use the React-specific entry point to import createApi
import type {
  BulletinRequest,
  BulletinResponse,
  GetBulletinListRequestV2,
  GetListResponseOfBulletinSimpleResponse,
} from 'src/api/ProactApiClient';
import {bulletinApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const bulletinApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getBulletinListV2: builder.query<
      GetListResponseOfBulletinSimpleResponse,
      GetBulletinListRequestV2
    >({
      queryFn: clientQuery(params => bulletinApiClient.listV2(params)),
      providesTags: ['Bulletins'],
    }),
    getBulletin: builder.query<BulletinResponse, number>({
      queryFn: clientQuery(id => bulletinApiClient.get(id)),
      providesTags: ['Bulletins'],
    }),
    getActiveBulletin: builder.query({
      queryFn: clientQuery(() => bulletinApiClient.getActive()),
      providesTags: ['Bulletins'],
    }),
    createBulletin: builder.mutation<BulletinResponse, BulletinRequest>({
      queryFn: clientQuery(request => bulletinApiClient.create(request)),
      invalidatesTags: ['Bulletins'],
    }),
    updateBulletin: builder.mutation<BulletinResponse, BulletinRequest>({
      queryFn: clientQuery(request => bulletinApiClient.update(request)),
      invalidatesTags: ['Bulletins'],
    }),
    deleteBulletin: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => bulletinApiClient.delete(id)),
      invalidatesTags: ['Bulletins'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetBulletinListV2Query,
  useGetBulletinQuery,
  useGetActiveBulletinQuery,
  useCreateBulletinMutation,
  useUpdateBulletinMutation,
  useDeleteBulletinMutation,
} = bulletinApi;
